import { Accordion, Alert, Button, Group, Loader, TextInput } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useState } from 'react';
import { axiosWrapper } from './utils.ts';

export const ShowAccessShared = () => {
    const [value, setValue] = useState('shared1@virtualworkforceai.onmicrosoft.com')
    const [email, setEmail] = useState('')
    const { data, isLoading, error, refetch, isRefetching } = useQuery({
        queryKey: ['shared', email],
        queryFn: () => axiosWrapper(axios({
            url: `/api/shared/${email}`,
        })),
        enabled: !!email,
    })

    return (
        <div>
            <div>
                <Group grow>
                    <TextInput
                        value={value}
                        onChange={(e) => setValue(e.currentTarget.value)}
                    />
                    <Group grow>
                        <Button onClick={() => setEmail(value)} disabled={email === value}>
                            Fetch shared emails
                        </Button>
                        <Button onClick={() => refetch()} disabled={!email} loading={isRefetching}>
                            Refresh
                        </Button>
                    </Group>
                </Group>
            </div>

            {error && (
                <Alert color="red" mt="md">
                    Error! {JSON.stringify(error)}
                </Alert>
            )}
            {isRefetching && (
                <Loader type="dots" />
            )}
            {((!data && !error && !!email) || isLoading) ? (
                <Loader />
            ) : (
                <Accordion mt="md">
                    {data?.value?.map(item => (
                        <Accordion.Item key={item.id} value={item.id}>
                            <Accordion.Control>{item.subject}</Accordion.Control>
                            <Accordion.Panel>
                                <iframe
                                    srcDoc={item.body?.content || item.bodyPreview}
                                    style={{ width: '100%', height: '300px', border: 'none' }}
                                ></iframe>
                            </Accordion.Panel>
                        </Accordion.Item>
                    ))}
                    {data?.value?.length === 0 && (
                        <Alert color="cyan" mt="md">
                            No emails found in the mailbox.
                        </Alert>
                    )}
                </Accordion>
            )}
        </div>
    )
}
